import { useForm, useFormContext } from 'react-hook-form';

export interface CarrierContractUpsert {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  carrier_configuration_data?: Record<string, any>;
  update_mask?: string[];
  description?: string;
  schema_id?: string;
  name: string;
}

/**
 * This type is used to fix types of dynamic forms.
 */
export type DynamicPath = 'carrier_configuration_data';

export const useCarrierContractForm = useForm<CarrierContractUpsert>;
export const useCarrierContractFormContext = useFormContext<CarrierContractUpsert>;
